<template>

<div>

    <div class="list-loader-outer">
        <transition name="loader-fade">
            <div class="list-loader" v-if="loading">
                <div class="loader"></div>
            </div>
        </transition>
    </div>

    <h1>Inköpskanaler
        <a href="/affiliates/new" class="btn btn-default btn-sm">
          Lägg till
        </a>
    </h1>

    <div class="searchbar">

        <div>

            <div class="block freetext" v-bind:class="{ active: search.text != '' && search.text != null }">

                <input class="form-control" v-on:keyup="updateQuery()" v-model="search.text" placeholder="Sök id, namn, konto" />

            </div>

          <div class="block" v-bind:class="{ active: search.product_area_id != null }">
            <label>
              <select v-model="search.product_area_id" v-on:change="updateQuery()">
                <option v-bind:value="undefined">Tjänsteområde</option>
                <option v-bind:value="area.id" v-for="area in product_areas">{{ area.name }}</option>
              </select>
            </label>
          </div>

                <div class="block" v-bind:class="{ active: search.is_active == 1 }">
                    <label>
                        <input type="checkbox" v-on:change="updateQuery()" v-model="search.is_active" /> Aktiva
                    </label>
                </div>

                <a data-toggle="modal" data-target="#myModal" class="btn btn-sm btn-default pull-right">
                    <i class="fa fa-file" aria-hidden="true"></i> Spara excel</i>
                </a>

              <br clear="all">

        </div>

    </div>

</div>

</template>

<script>

export default {
    props: {
        query: {
            required: true
        },
        loading: {},
        searchbarData: {}
    },
    data: function () {
        return {
            search: {},
            product_areas: this.searchbarData.product_areas
        }
    },
    methods: {

        updateQuery: function () {
            this.$emit('search', this.search)
        }
    },
    watch: {
        query: function () {
            this.search = this.query
        }
    }
}

</script>
